import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  SaveItemCategory,
  UpdateItemCategory,
  getAllGroups,
  getAllFactoriesByGroupID,
  GetItemCategoryDetailsByGroupIDFactoryID,
  GetItemCategoryDetailsByItemCategoryID
};

async function SaveItemCategory(factoryItem, userID) {
  let saveModel = {
    itemCategoryID: 0,
    categoryName: factoryItem.categoryName,
    shortCode: factoryItem.shortCode,
    categoryCode: factoryItem.categoryCode,
    categoryDescription: factoryItem.categoryDescription,
    groupID: parseInt(factoryItem.groupID),
    factoryID: parseInt(factoryItem.factoryID),
    isActive: factoryItem.isActive,
    createdBy: parseInt(userID)
  }
  const response = await CommonPost('/api/ItemCategory/SaveItemCategory', null, saveModel);
  return response;
}

async function UpdateItemCategory(updateModel) {
  const response = await CommonPost('/api/ItemCategory/UpdateItemCategory', null, updateModel);
  return response;
}

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getAllFactoriesByGroupID(groupID) {
  let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
  let factoryArray = []
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function GetItemCategoryDetailsByGroupIDFactoryID(groupID, factoryID) {
  const response = await CommonGet('/api/ItemCategory/GetItemCategoryDetailsByGroupIDFactoryID', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response;
}

async function GetItemCategoryDetailsByItemCategoryID(itemCategoryID) {
  const response = await CommonGet('/api/ItemCategory/GetItemCategoryDetailsByItemCategoryID', "itemCategoryID=" + parseInt(itemCategoryID));
  return response.data;
}
